import initialState from "../../../store/initialState";
import * as types from "../services/TenantHierarchyConfigurationActionType";

const tenantHierarchyConfigurationReducer = (
  state = initialState.tenantHierarchyConfigurationReducer,
  action,
) => {
  switch (action.type) {
    case types.GET_MASTER_HIERARCHY_REQUEST:
    case types.GET_TENANT_HIERARCHY_CONFIGURATION_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case types.GET_MASTER_HIERARCHY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        masterHierarchy: action.payload,
        error: null,
      };

    case types.GET_TENANT_HIERARCHY_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tenantHierarchyConfiguration: action.payload,
        error: null,
      };

    case types.GET_MASTER_HIERARCHY_FAILURE:
    case types.GET_TENANT_HIERARCHY_CONFIGURATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.SAVE_TENANT_HIERARCHY_CONFIGURATION_REQUEST:
      return {
        ...state,
        isSaving: true,
        isSaved: false,
        error: null,
      };

    case types.SAVE_TENANT_HIERARCHY_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isSaving: false,
        isSaved: true,
        error: null,
      };

    case types.SAVE_TENANT_HIERARCHY_CONFIGURATION_FAILURE:
      return {
        ...state,
        isSaving: false,
        isSaved: false,
        error: action.payload,
      };

    case types.BULK_UPDATE_TENANT_HIERARCHY_ALIAS_REQUEST:
      return {
        ...state,
        isBulkSaving: true,
        isAliasUpdated: false,
        error: null,
      };

    case types.BULK_UPDATE_TENANT_HIERARCHY_ALIAS_SUCCESS:
      return {
        ...state,
        isBulkSaving: false,
        isAliasUpdated: true,
        error: null,
      };

    case types.BULK_UPDATE_TENANT_HIERARCHY_ALIAS_FAILURE:
      return {
        ...state,
        isBulkSaving: false,
        isAliasUpdated: false,
        error: action.payload,
      };

    case types.RESET_TENANT_HIERARCHY_CONFIGURATION_FLAGS:
      return {
        ...state,
        isSaved: false,
        isAliasUpdated: false,
      };

    default:
      return state;
  }
};

export default tenantHierarchyConfigurationReducer;
